import { render, staticRenderFns } from "./supplier-commitment-viewer.vue?vue&type=template&id=6a58f274&scoped=true"
import script from "./supplier-commitment-viewer.vue?vue&type=script&lang=js"
export * from "./supplier-commitment-viewer.vue?vue&type=script&lang=js"
import style0 from "./supplier-commitment-viewer.vue?vue&type=style&index=0&id=6a58f274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58f274",
  null
  
)

export default component.exports